import { render, staticRenderFns } from "./section-categories.vue?vue&type=template&id=b1740076&scoped=true&"
import script from "./section-categories.vue?vue&type=script&lang=js&"
export * from "./section-categories.vue?vue&type=script&lang=js&"
import style0 from "./section-categories.vue?vue&type=style&index=0&id=b1740076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1740076",
  null
  
)

export default component.exports